import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EmployeeApplicationFormComponent } from '../employee-application-form/employee-application-form.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { HttpService } from 'src/app/service/http/http.service';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { AddElcmCandidateComponent } from '../add-elcm-candidate/add-elcm-candidate.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ConvertElcmPopupComponent } from '../convert-elcm-popup/convert-elcm-popup.component';
import { SharedService } from 'src/app/service/shared/shared.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-elcm-employee-application-report',
  templateUrl: './elcm-employee-application-report.component.html',
  styleUrls: ['./elcm-employee-application-report.component.scss'],
})
export class ElcmEmployeeApplicationReportComponent implements OnInit {

  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any
  pmsYears: any = [];
  selectedYear: any;
  dropdownSettings: IDropdownSettings = {};
  constructor(private datePipe: DatePipe,
    public sharedService: SharedService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,

    private encryptionService: EncryptionService,

    public dialogRef: MatDialogRef<ElcmEmployeeApplicationReportComponent>,
  ) {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }

  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getpmsyearlist();

   
  

  }

//   getpmsyearlist() {
//     this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
//       this.pmsYears = [];

//       data?.data?.yearRanges?.forEach((ele: any) => {
//         var test = ele.split('_');
//         let obj = {
//           year: test[0] + '-' + test[1]
//         };

//         // Get current year
//         const currentYear = new Date().getFullYear();

//         // Ensure only past and current years are included
//         var yearParts = obj.year.split('-');
//         let fromYear = parseInt(yearParts[0]);
//         let toYear = parseInt(yearParts[1]);

//         // Add to pmsYears only if it's not a future year
//         if (toYear <= currentYear) {
//           this.pmsYears.push(obj);
//         }
//       });

//       // Iterate over the years and set the selected year for various fields
//       this.pmsYears?.forEach((ele: any) => {
//         const currentYear = new Date().getFullYear();
//         let yearValue = '';
//         if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {

//           yearValue = `${currentYear}-${currentYear}`; // Calendar year
//         } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {

//           if (new Date().getMonth() < 3) {
//             // If it's Jan, Feb, or Mar, we're in the previous fiscal year
//             yearValue = `${currentYear - 1}-${currentYear}`;
//           } else {
//             // From Apr onwards, it's the current fiscal year
//             yearValue = `${currentYear}-${currentYear + 1}`;
//           }
//         }
// console.log(yearValue);

//         if (ele?.year == yearValue) {
//           console.log("dgmfdgl");

//           this.selectedYear = ele?.year;


//           this.getEmployeeList();

//         }


//       });
//     })
//   }



  
    getpmsyearlist() {
      this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
        this.pmsYears = formatYearRanges(data?.data?.yearRanges);
  
        const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
  
        const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
    
        this.setSelectedYear(yearValue);
      // Additional function calls
      this.getEmployeeList();
      });
    }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');
         
    }
  }
  selectDepartMent: number = -1;
  selectEmployee: number = -1;
  viewReimbursementReportByYear(event: any) { 
    this.selectedEmployee=[]
    this.selectedYear=event;
    this.getEmployeeList();
  }
  OfferAndAppointmentTableHeader: any = [

    { label: "Solutation" },
    { label: "First Name" },
    { label: "Last Name" },
    { label: "Personal Email" },
    { label: "Gender" },
    { label: "Present Address" },
    { label: "Permanent Address" },
    { label: "Country" },
    { label: "Marital Status" },
    { label: "Date of Birth" },
    { label: "Age" },
    { label: "AdharCard No" },
    { label: "PAN No" },
    { label: "UAN No" },
    { label: "Mobile No (Whats app no)" },
    { label: "Total Prev Exp Before Joining" },
    { label: "Emergency Contact Number" },
    { label: "Blood Group" },
    { label: "Father's Name" },
    { label: "Mother's Name" },
    { label: "Spouse's Name" },
    { label: "No.of Children" },
    { label: "Relative Working" },

    // Education Related Information
    { label: "Highest Education" },
    { label: "Highest Education Institute" },
    { label: "Highest Education Year" },
    { label: "Highest Education Marks" },
    { label: "Second Education" },
    { label: "Second Education Institute" },
    { label: "Second Education Year" },
    { label: "Second Education Marks" },
    { label: "Third Education" },
    { label: "Third Education Institute" },
    { label: "Third Education Year" },
    { label: "Third Education Marks" },
    { label: "Highest Professional Education" },
    { label: "Highest Professional Institute" },
    { label: "Highest Professional Year" },
    { label: "Highest Professional Marks" },

    // Prior Employment Related Information
    { label: "Last Organisation" },
    { label: "Last Organisation Joining Date" },
    { label: "Last Organisation Last Working Date" },
    { label: "Last Organisation Department" },
    { label: "Last Organisation Designation" },
    { label: "Last-to-Last Organisation" },
    { label: "Last-to-Last Organisation Joining Date" },
    { label: "Last-to-Last Organisation Last Working Date" },
    { label: "Last-to-Last Organisation Department" },
    { label: "Last-to-Last Organisation Designation" },
    { label: "Any Other Organisation" },
    { label: "Any Other Organisation Joining Date" },
    { label: "Any Other Organisation Last Working Date" },
    { label: "Any Other Organisation Department" },
    { label: "Any Other Organisation Designation" }
  ]

  employees: any = []
  getEmpList:any=[]
  searchTerm: any = ''; // Holds search input value
  filteredEmployees: any[] = []; // Holds filtered employee list
  getEmployeeList() {
    this.httpService.callGetService(`${this.config.convertEmployeeList}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {
      this.filteredEmployees = record.data;
      this.employees = this.filteredEmployees; // Initialize filtered list
      this.getEmpList=[]
      this.filteredEmployees.forEach((ele: any) => {
 // if (!this.getEmpList.some((record: any) =>record.name.trim().toLowerCase() === ele.empName.trim().toLowerCase())) {
  if (!this.getEmpList.some((record: any) => 
    record.id === ele.id && 
    record.name.trim().toLowerCase() === (ele.firstName + " " + ele.lastName).trim().toLowerCase()
)) {
  this.getEmpList.push({
    id: ele.id,
    name: (ele.firstName + " " + ele.lastName).trim(), // Ensuring a proper format with a space
  });
}

  


      });
     
      console.log(this.getEmpList);
      
    })
  }

  filterEmployees() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      return this.employees; // Return full list if no search term
    }
    const searchTextLower = this.searchTerm.toLowerCase().trim();
     let data = this.filteredEmployees.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );

    this.employees = data;


  }

  fiterDataForDep() {

    if (this.selectedEmployee?.length > 0) {

      const deptID = this.selectedEmployee.map((elm: any) => elm.id);


     this.employees = this.filteredEmployees.filter((record: any) => deptID.includes(record.id));
    
      // this.currentassetAllocationFromAuthority = this.assetAllocationFromAuthority;
      // this.getEmployeeList = [];
      // const uniqueNames = new Set();

      // this.assetAllocationFromAuthority.forEach((ele: any) => {
      //   const name = ele.employeeName?.trim(); // Ensure name is consistent and trimmed
      //   if (name && !uniqueNames.has(name)) { // Check if the name is not already added
      //     uniqueNames.add(name); // Add name to the Set
      //     const obj = {
      //       id: ele.userId,
      //       name: name,
      //       deptId: ele.id
      //     };
      //     this.getEmployeeList.push(obj);
      //   }
      // });

    }

    else {
      // this.clearSelections();

       this.employees = this.filteredEmployees;

    }


  }
  clearSelections(){}
  selectedEmployee: any = [];
  onSelectEmployee() {
    // Ensure selectedEmployeeartment is an array and has selected items
    if (this.selectedEmployee && this.selectedEmployee.length > 0) {
      this.fiterDataForDep();
    } else {
      this.clearSelections(); // Clear selections if no department is selected
    }
  }

  onDeSelectEmployee() {
    // this.selectedEmployee = [];
    this.fiterDataForDep();
  }

  selectAllEmployee(items: any): void {
    this.selectedEmployee = items; // Select all departments
     this.fiterDataForDep();

  }


  onDeSelectAllEmployee() {
    this.selectedEmployee = [];
     this.selectedEmployee = [];
    // this.getEmployeeList = [];
    // this.assetAllocationData()

  }


  DislaySelectedRecord(event: any) {
    this.employees = this.filteredEmployees.slice(0, event.value);
  }




  downloadEmployeeList() {
    if (!this.employees || this.employees.length === 0) {
      console.warn('No data available for export');
      return;
    }

    // Extract dynamic headers from OfferAndAppointmentTableHeader
    const headers = this.OfferAndAppointmentTableHeader.map((header: any) => header.label);

    // Extract dynamic employee data
    const employeeData = this.employees.map((employee: any) => {
      const row: any = {};
      this.OfferAndAppointmentTableHeader.forEach((header: any) => {
        const key = this.mapHeaderToKey(header.label);
        row[header.label] = employee[key] || '';
      });
      return row;
    });

    // Convert to Excel format
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(employeeData);
    const workbook: XLSX.WorkBook = { Sheets: { 'Employees': worksheet }, SheetNames: ['Employees'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Convert to Blob and trigger download
    const data: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(data, 'Employee_List.xlsx');
  }

  // Mapping function to match label with the correct key in employee object
  mapHeaderToKey(label: string): string {
    const mapping: { [key: string]: string } = {
      "Solutation": "salutation",
      "First Name": "firstName",
      "Last Name": "lastName",
      "Personal Email": "email",
      "Gender": "gender",
      "Present Address": "address",
      "Permanent Address": "permanentAddress",
      "Country": "country",
      "Marital Status": "maritalStatus",
      "Date of Birth": "dateOfBirth",
      "Age": "age",
      "AdharCard No": "aadharNo",
      "PAN No": "panNo",
      "UAN No": "uan",
      "Mobile No (Whats app no)": "contactNo",
      "Total Prev Exp Before Joining": "totalExperience",
      "Emergency Contact Number": "emergencyContactNo",
      "Blood Group": "bloodGroup",
      "Father's Name": "fathersName",
      "Mother's Name": "mothersName",
      "Spouse's Name": "spouseName",
      "No.of Children": "noOfChildren",
      "Relative Working": "isRelativeWorking",
      "Highest Education": "highestEducationQualification",
      "Highest Education Institute": "highestEducationInstitute",
      "Highest Education Year": "highestEducationYearOfPassing",
      "Highest Education Marks": "highestEducationMarks",
      "Second Education": "highestEducationQualification2",
      "Second Education Institute": "highestEducationInstitute2",
      "Second Education Year": "highestEducationYearOfPassing2",
      "Second Education Marks": "highestEducationMarks2",
      "Third Education": "highestEducationQualification3",
      "Third Education Institute": "highestEducationInstitute3",
      "Third Education Year": "highestEducationYearOfPassing3",
      "Third Education Marks": "highestEducationMarks3",
      "Highest Professional Education": "highestProfessionalQualification",
      "Highest Professional Institute": "highestProfessionalInstitute",
      "Highest Professional Year": "highestProfessionalYearOfPassing",
      "Highest Professional Marks": "highestProfessionalMarks",
      "Last Organisation": "lastOrganisationName",
      "Last Organisation Joining Date": "lastOrganisationDoj",
      "Last Organisation Last Working Date": "lastOrganisationLwd",
      "Last Organisation Department": "lastOrganisationDepartment",
      "Last Organisation Designation": "lastOrganisationDesignation",
      "Last-to-Last Organisation": "lastToLastOrganisationName",
      "Last-to-Last Organisation Joining Date": "lastToLastOrganisationDoj",
      "Last-to-Last Organisation Last Working Date": "lastToLastOrganisationLwd",
      "Last-to-Last Organisation Department": "lastToLastOrganisationDepartment",
      "Last-to-Last Organisation Designation": "lastToLastOrganisationDesignation",
      "Any Other Organisation": "otherOrganisationName",
      "Any Other Organisation Joining Date": "otherOrganisationDoj",
      "Any Other Organisation Last Working Date": "otherOrganisationLwd",
      "Any Other Organisation Department": "otherOrganisationDepartment",
      "Any Other Organisation Designation": "otherOrganisationDesignation"
    };

    return mapping[label] || label; // Return mapped key or fallback to the label
  }
  employeeApplicationForm(candidateDetails: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%'; // Adjust as needed
    dialogConfig.width = '100%'; // Adjust as needed

    dialogConfig.data = {
      popupName: 'Employee Application',
      candidateId: candidateDetails,

    };
    dialogConfig.panelClass = 'custom-dialog-container';

    const dialogRef = this.dialog.open(EmployeeApplicationFormComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dialog result:', result);
        // Perform actions based on result
      }
    });
  }
  convertEmployeeCode(candidateDetails: any) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      candidateData: candidateDetails
    };

    const dialogRef = this.dialog.open(ConvertElcmPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getEmployeeList();

    });
  }

  addCandidate() {


    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {

    };

    const dialogRef = this.dialog.open(AddElcmCandidateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getEmployeeList();

    });



  }
}
